export default __webpack_public_path__ + "static/media/info-grey.77932f65.svg";